(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('PeopleFormController', PeopleFormController)

    /** @ngInject */
    function PeopleFormController($q, $scope, $rootScope, $state, $stateParams, LoadingHelper, PersonService,
        AuthenticationService, sweetAlert, ResponsibilityService, UtilHelper,ImagePathHelper, DEFAULT_IDENTIFIERS, DATA_EVENTS) {
        const vm = this;
        const personId = $stateParams.personId;
        let allResponsibilities;

        vm.updateUserAssociations = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação irá alterar a associação da pessoa com as permissões selecionadas!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value)
                    updateUserAssociations();
            })
        }

        vm.removeAssociation = personCompany => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você irá remover a associação da pessoa com essa empresa, ela não poderá mais visualizar os dados!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    personCompany.Block = true;

                    deleteCompanyAssociation(personCompany);
                }
            })
        }

        vm.isLoggedPersonCurrentCompany = companyId => {
            return $rootScope.canUserEdit && companyId == vm.loggedUserData.Company.Id;
        }

        vm.getResponsibilities = company => {
            if (!company.CompanyIdParent)
                return allResponsibilities.filter(resp => (resp.Id != 4));

            return allResponsibilities;
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_COMPANY_CHANGE, () => {
            $state.go('app.people-list');
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function updateUserAssociations() {
            LoadingHelper.startLoading('.loading-holder');

            let personCompanyFinal = vm.personData.PersonCompanies
                .filter(personDataUnit => (vm.isLoggedPersonCurrentCompany(personDataUnit.CompanyId)))
                .reduce((acc, cur) => {
                    let associationData = {
                        CompanyId: cur.CompanyId,
                        PersonId: vm.personData.Id,
                        ResponsibilityId: cur.ResponsibilityId,
                        PermissionGroupId: cur.ResponsibilityId != 4 ? DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER : DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE,
                        Block: cur.Block,
                        Id: cur.Id
                    };

                    acc.push(associationData);

                    return acc;
                }, []);

            PersonService
                .updateCompanyAssociation(personCompanyFinal)
                .then(() => {
                    UtilHelper.successCallback('update');
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        function deleteCompanyAssociation(personCompany) {
            LoadingHelper.startLoading('.loading-holder');

            PersonService
                .deleteCompanyAssociation(personCompany.PersonId, personCompany.CompanyId)
                .then(() => {
                    vm.personData.PersonCompanies = vm.personData.PersonCompanies.filter(pc => (pc.CompanyId != personCompany.CompanyId));

                    UtilHelper.successCallback('delete');
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        function getPerson() {
            if (!personId) {
                sweetAlert.swal({
                    title: 'Não foi possível recuperar os dados da pessoa!',
                    text: 'Ocorreu um erro ao buscar o identificador da pessoa',
                    type: 'warning',
                    confirmButtonText: 'Ir para Home',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        LoadingHelper.stopLoading('.loading-holder');

                        $state.go('app.home');
                    }
                })

                return;
            }

            PersonService
                .get(personId)
                .then(success => {
                    if (success.RegistrationDate)
                        success.RegistrationDateFormatted = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.RegistrationDateFormatted = '-';

                    if (success.BirthDate)
                        success.BirthDateFormatted = moment(success.BirthDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.BirthDateFormatted = '-';

                    vm.personData = success;

                    // Show the franchiser only his current company on user association companies
                    if (vm.personData.PersonCompanies)
                        vm.personData.PersonCompanies = vm.personData.PersonCompanies.filter(personCompany => (vm.loggedUserData.Company.Id == personCompany.CompanyId));

                    if (vm.personData.Image) {
                        vm.mainImageData.image = vm.personData.Image;
                        vm.mainImageData.display = ImagePathHelper.imageResizePath('person', vm.personData.Id, vm.personData.Image, 150, 150);
                    }

                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function getGenders() {
            return PersonService
                .getGenders()
                .then(success => {
                    vm.genders = success;
                }, error => {
                    UtilHelper.errorCallback(error);
                })
        }

        function getResponsibilities() {
            return ResponsibilityService
                .getAll()
                .then(success => {
                    allResponsibilities = success.Registers.filter(resp => (resp.Id != 4));
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.company-permission-listing');
                })
        }

        function initVars() {
            vm.loggedUserData = AuthenticationService.getUser();

            if (personId == vm.loggedUserData.PersonId) {
                $state.go('app.my-profile');
                return;
            }

            vm.selectedTab = 1;
            vm.mainImageData = {
                display: '',
                image: ''
            }
        }

        function init() {
            initVars();

            LoadingHelper.startLoading('.loading-holder');

            $q.all([getGenders(), getResponsibilities()])
                .then(() => {
                    getPerson();
                })
        }
    }
}());